import { getInterface } from '@/utils/js/initVariable'
const prefixUrl = 'api/SystemApi/'
export const updatePassword = (data)=>{
  return getInterface.post(`${prefixUrl}updatePassword`, data)
}